/* eslint-disable @typescript-eslint/no-explicit-any*/
interface CustomHTMLElement extends HTMLElement {
  eventSetDrag: () => void;
  eventClearDrag: () => void;
  eventOnClick: (event: MouseEvent) => void;
  eventOnTouch: (event: TouchEvent) => void;
}

export default {
  beforeMount: (el: CustomHTMLElement, binding: any) => {
    el.eventSetDrag = () => {
      el.setAttribute("data-dragging", "yes");
    };
    el.eventClearDrag = () => {
      el.removeAttribute("data-dragging");
    };
    el.eventOnClick = (event) => {
      event.stopPropagation();
      const dragging = el.getAttribute("data-dragging");
      // Check that the click was outside the el and its children, and wasn't a drag
      if (
        !document
          .elementsFromPoint(event.clientX, event.clientY)
          .includes(el) &&
        !dragging
      ) {
        // call method provided in attribute value
        binding.value(event);
      }
    };
    el.eventOnTouch = (event) => {
      event.stopPropagation();
      const dragging = el.getAttribute("data-dragging");
      // Check that the click was outside the el and its children, and wasn't a drag
      const { pageX, pageY } = event.changedTouches[0];
      if (!document.elementsFromPoint(pageX, pageY).includes(el) && !dragging) {
        // call method provided in attribute value
        binding.value(event);
      }
    };
    document.addEventListener("touchstart", el.eventClearDrag);
    document.addEventListener("touchmove", el.eventSetDrag);
    document.addEventListener("click", el.eventOnClick);
    document.addEventListener("touchend", el.eventOnTouch);
  },
  unmounted: (el: CustomHTMLElement) => {
    document.removeEventListener("touchstart", el.eventClearDrag);
    document.removeEventListener("touchmove", el.eventSetDrag);
    document.removeEventListener("click", el.eventOnClick);
    document.removeEventListener("touchend", el.eventOnTouch);
    el.removeAttribute("data-dragging");
  },
};
